<template>
  <div class="reward-list">
    <div class="list">
      <router-link tag="div" :to="'./reward-detail/'+item.order_no" class="item" v-for="(item, index) in list" :key="index">
        <div>
          <!-- 提现 -->
          <div v-if="item.transaction_type=='1'">{{$t(langKey+'.type1')}}</div>
          <!-- 奖励 -->
          <div v-else-if="item.transaction_type=='3'">{{$t(langKey+'.type2')}}</div>
          <span>{{item.created}}</span>
        </div>
        <div class="right">
          <div><span v-if="item.transaction_type=='1'">-</span><span v-else-if="item.transaction_type=='3'">+</span>{{item.amount}}</div>
          <span v-if="item.status == '0'">{{$t(langKey+'.status3')}}</span>
          <span v-else-if="item.status == '1'">{{$t(langKey+'.status1')}}</span>
          <span v-else-if="item.status == '2'">{{$t(langKey+'.status2')}}</span>
        </div>
      </router-link>
    </div>
    <div class="no-more" v-if="!list.length">{{$t(langKey+'.noMore')}}</div>
  </div>
</template>
<script type="text/ecmascript-6">
import { setTitle } from 'components/mixin/title'
import { mapGetters } from 'vuex'
import { getIncomeList } from 'api/me'

export default {
  data() {
    return {
      langKey: this.$route.name,
      list: []
    }
  },
  computed: {
    ...mapGetters(['lang', 'userInfo', 'isAbroad'])
  },
  mixins: [setTitle],
  created() {
    // 有联系方式才发送请求
    if (this.userInfo.mobile || this.userInfo.email) {
      this._getIncomeList()
    }
  },
  methods: {
    _getIncomeList() {
      let contact = this.isAbroad ? this.userInfo.email : this.userInfo.mobile
      this.$loading.open()
      getIncomeList(contact).then(res => {
        console.log(res)
        this.list = res.data
        this.$loading.close()
      }).catch(err => {
        console.error(err)
        this.$loading.close()
      })
    }
  },
  watch: {
    userInfo(nv) {
      this._getIncomeList()
    }
  }
}
</script>
<style scoped lang="scss">
  @import "css/def";
  .reward-list{
    min-height: 100vh;
    background:rgba(241,241,241,1);
    .list{
      .item{
        height: size(170);
        width: 100%;
        background-color: #fff;
        @include flex();
        justify-content: space-between;
        padding: 0 size(32);
        font-size: size(30);
        color: #333;
        @include border('bottom');
        >div{
          >div{
            margin-bottom: size(20);
            font-weight: 600;
            span{
              display: inline-block;
              position: relative;
              top: -1px;
            }
          }
          >span{
            font-size: size(24);
            color: #999999;
          }
          &.right{
            text-align: right;
          }
        }
      }
    }
  }
  .no-more{
    text-align: center;
    color: #999;
    font-size: size(28);
    padding-top: size(50);
  }
</style>



// WEBPACK FOOTER //
// src/views/me/reward-list.vue